export const PUBLIC_SITE_HOSTS = new Set(["www.echojham.site", "echojham.site"]);
export const ADMIN_SITE_HOST = "admin.echojham.site";
export const PUBLIC_SITE_ORIGIN = "https://www.echojham.site";
export const ADMIN_SITE_ORIGIN = "https://admin.echojham.site";

export const isLocalHost = (hostname) => {
  const host = String(hostname || "").toLowerCase().split(":")[0];
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host.endsWith(".local")
  );
};

export const isAdminPath = (pathname) => {
  const path = String(pathname || "");
  return path === "/admin-login" || path === "/admin" || path.startsWith("/admin/");
};

export const isAdminHostAllowedPath = (pathname) => {
  const path = String(pathname || "");
  if (isAdminPath(path)) return true;
  return path === "/auth/callback" || path === "/reset-password";
};

export const isPublicAdminBlockedHost = (hostname) =>
  PUBLIC_SITE_HOSTS.has(String(hostname || "").toLowerCase().split(":")[0]);

export const resolveAdminHostAction = ({
  hostname,
  pathname,
  search = "",
  hash = "",
} = {}) => {
  if (isLocalHost(hostname)) return null;

  const host = String(hostname || "").toLowerCase().split(":")[0];
  const path = String(pathname || "/");
  const suffix = `${search || ""}${hash || ""}`;

  if (isPublicAdminBlockedHost(host) && isAdminPath(path)) {
    return { type: "notfound" };
  }

  if (host === ADMIN_SITE_HOST) {
    if (path === "/" || path === "") {
      return { type: "redirect", to: `/admin-login${suffix}` };
    }
    if (!isAdminHostAllowedPath(path)) {
      return { type: "redirect", to: `${PUBLIC_SITE_ORIGIN}${path}${suffix}` };
    }
  }

  return null;
};
